import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                黑桃视频
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              黑桃视频致力于为用户提供最新最全的视频内容推荐服务，涵盖电影、电视剧、综艺、动漫、纪录片等各类精彩内容。高清流畅播放，每日更新。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/category/dianying" className="text-sm text-background-300 hover:text-primary-400 transition-colors">电影推荐</Link></li>
              <li><Link to="/category/dianshiju" className="text-sm text-background-300 hover:text-primary-400 transition-colors">电视剧推荐</Link></li>
              <li><Link to="/category/zongyi" className="text-sm text-background-300 hover:text-primary-400 transition-colors">综艺节目</Link></li>
              <li><Link to="/category/dongman" className="text-sm text-background-300 hover:text-primary-400 transition-colors">动漫番剧</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              <span className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300">科幻大片</span>
              <span className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300">国产好剧</span>
              <span className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300">爆笑综艺</span>
              <span className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300">高分动漫</span>
              <span className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300">纪录片</span>
              <span className="px-3 py-1 text-xs rounded-full bg-background-800 text-background-300">悬疑推理</span>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors">联系我们</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {currentYear} 黑桃视频. 本站内容仅供学习交流使用，所有版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 hover:text-background-200 text-sm" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-400 hover:text-background-200 text-sm" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}